<buyiq-sort-menu-option (selectOption)="onSelectSortOption($event)"
                        *ngFor="let option of sortOptions"
                        [isSelected]="option.isSelected"
                        [sortDirection]="option.sortDirection"
                        [sortOption]="option"
                        mat-ripple>
</buyiq-sort-menu-option>
